import type { CaptureManifest } from "./types";

export function toPersistedManifest(
  manifest: CaptureManifest
): Omit<CaptureManifest, "screenshot"> & { screenshot: string } {
  return {
    id: manifest.id,
    timestamp: manifest.timestamp,
    url: manifest.url,
    pathname: manifest.pathname,
    branchId: manifest.branchId,
    pageEntity: manifest.pageEntity,
    appVersion: manifest.appVersion,
    captureType: manifest.captureType,
    summary: manifest.summary,
    target: manifest.target,
    context: manifest.context,
    surface: manifest.surface,
    uiState: manifest.uiState,
    fixHints: manifest.fixHints,
    ...(manifest.tableRecord ? { tableRecord: manifest.tableRecord } : {}),
    react: manifest.react,
    failedRequests: manifest.failedRequests,
    screenshot:
      manifest.captureType === "screenshot" ? "screenshot.png" : "",
    recording: manifest.recording,
  };
}

export function serializeManifest(manifest: Record<string, unknown>): string {
  return JSON.stringify(manifest);
}
